// import List from "./List";
// import data from "./data";
// import { useState } from "react"; // hook per gestire lo stato

// function App() { // people: l'array di persone attualmente visualizzato
//   //setpeople:  la funzione per aggiornarlo
//   //const [people, setPeople] =useState(data); //useState(data) — inizializza lo stato con i dati importati da data.js
//   const [showForm, setShowForm] = useState(false);



//   // Carica dal localStorage se esiste, altrimenti usa data.js
//   // const [people, setPeople] = useState(() => {
//   //   const saved = localStorage.getItem("appuntamenti");
//   //   return saved ? JSON.parse(saved) : data;
//   // });

//   // Carica dal localStorage se esiste, altrimenti usa data.js
//   const [people, setPeople] = useState(() => {
//     const saved = localStorage.getItem("appuntamenti");
//     return saved ? JSON.parse(saved) : data;
//   });

//   // Salva nel localStorage ogni volta che people cambia
//   // const savePeople = (newPeople) => {
//   //   setPeople(newPeople);
//   //   localStorage.setItem("appuntamenti", JSON.stringify(newPeople));
//   // };
//   const savePeople = (newPeople) => {
//     setPeople(newPeople);
//     localStorage.setItem("appuntamenti", JSON.stringify(newPeople));
//   };

//   //Elimina una persona:
//   const removeItem = (id) => { //Riceve l'id della persona da eliminare
//     savePeople(people.filter((value) => value.id !== id));
//   //   setPeople((oldValue) => oldValue.filter //.filter() crea un nuovo array tenendo solo le persone il cui id è diverso da quello passato — quella con l'id uguale viene quindi esclusa
//   // ((value) => value.id !== id)); //oldValue => ... è la forma funzionale di setPeople: garantisce di lavorare sempre sul valore più aggiornato dello stato
//   };

//   const [formData, setFormData] = useState({
//     nome: "",
//     stato: "",
//     img: "",
//     data: "",
//     ora: "",
//     luogo: ""
//   });

//   //Ricarica tutti:
//   const reloadAllItem = () =>{
//     const saved = localStorage.getItem("appuntamenti");
//     setPeople(saved ? JSON.parse(saved) : data);
//    // savePeople(data);
//   //  setPeople(data);
  
//    // setPeople(saved ? JSON.parse(saved) : data);
//   }; //Resetta people all'array originale importato da data.js
// // data non cambia mai, è solo un array statico usato come "sorgente di verità"

// const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const aggiungiAppuntamento = (e) => {
//     e.preventDefault();
//     const nuovoAppuntamento = {
//       ...formData,
//       id: new Date().getTime() // id univoco
//     };
//     savePeople([...people, nuovoAppuntamento]);
//     //setPeople([...people, nuovoAppuntamento]);
//     setShowForm(false);
//     setFormData({ nome: "", stato: "", img: "", data: "", ora: "", luogo: "" });
//   };








//   // Due stati separati
// const [customAppointments, setCustomAppointments] = useState(() => {
//   const saved = localStorage.getItem("appuntamenti");
//   return saved ? JSON.parse(saved) : [];
// });

// // La lista completa è sempre la somma dei due
// const people = [...data, ...customAppointments];

// // Salva solo i custom
// const savePeople = (newCustom) => {
//   setCustomAppointments(newCustom);
//   localStorage.setItem("appuntamenti", JSON.stringify(newCustom));
// };

// // Reload: resetta solo i custom (data.js è già sempre presente)
// const reloadAllItem = () => {
//   setCustomAppointments([]);
//   localStorage.removeItem("appuntamenti");
// };

// // Elimina: se è un appuntamento custom lo rimuove, se è originale lo ignora
// const removeItem = (id) => {
//   savePeople(customAppointments.filter((p) => p.id !== id));
// };

// // Aggiungi: salva solo nei custom
// const aggiungiAppuntamento = (e) => {
//   e.preventDefault();
//   const nuovo = { ...formData, id: new Date().getTime() };
//   savePeople([...customAppointments, nuovo]);
//   setShowForm(false);
//   setFormData({ nome: "", stato: "", img: "", data: "", ora: "", luogo: "" });
// };

// // Delete all: svuota solo i custom
// // onClick={() => savePeople([])}

//   return (
//     <section>
//       <div className="container">
//         <h2 style={{ color: "var(--bg-blue)" }}>Agenda Appuntamenti</h2>
//         <div className="people-list">
//           {/* Passa lo stato people e la funzione removeItem verso il basso, a List.js */}
//           <List data={people} removeItem={removeItem} /> 
//           {/* Chiama la funzione reloadAllItem al click */}

//         </div>
//         {showForm && (
//           <form onSubmit={aggiungiAppuntamento} className="item">
//             <div>
//               <input name="nome" placeholder="Nome" value={formData.nome} onChange={handleChange} required />
//               <input name="stato" placeholder="Stato" value={formData.stato} onChange={handleChange} />
//               <input name="img" placeholder="URL immagine" value={formData.img} onChange={handleChange} />
//               <input name="data" placeholder="Data (gg-mm-aaaa)" value={formData.data} onChange={handleChange} />
//               <input name="ora" placeholder="Ora (hh:mm)" value={formData.ora} onChange={handleChange} />
//               <input name="luogo" placeholder="Luogo" value={formData.luogo} onChange={handleChange} />
//               <button type="submit" className="btn button">Salva</button>
//               <button type="button" className="btn" onClick={() => setShowForm(false)}>Annulla</button>
//             </div>
//           </form>
//         )}

//         <div className="btn-group">
//           <button className="btn btn-reset"
//           onClick={reloadAllItem}>
//             {" "}
//             Reload{" "}
//           </button>

//           <button className="btn btn-aggiungi" onClick={() => setShowForm(!showForm)}>
//            {showForm ? "Chiudi Form" : "Aggiungi Appuntamento"}
//           </button>


// {/* Svuota direttamente l'array — setPeople([]) imposta lo stato a un array vuoto, senza bisogno di una funzione separata */}
//           <button className="btn btn-delete"
//           onClick={()=>savePeople([])}>
//              {/* setPeople([])}> */}
//             {" "}
//             Delete all
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default App;


// // data.js  ──────────────────────────────►  useState(data)
// //                                                 │
// //                                            people (stato)
// //                                                 │
// //                                         <List data={people} />
// //                                                 │
// //                                     Person → click bottone 🗑️
// //                                                 │
// //                                          removeItem(id)
// //                                                 │
// //                                     setPeople(filter...) → re-render

// // Ogni volta che setPeople viene chiamata, React re-renderizza automaticamente l'interfaccia con i dati aggiornati.



import List from "./List";
import data from "./data";
import { useState } from "react";

function App() {
  const [showForm, setShowForm] = useState(false);

  const [people, setPeople] = useState(() => {
    const saved = localStorage.getItem("appuntamenti");
    if (!saved) {
      localStorage.setItem("appuntamenti", JSON.stringify(data));
      return data;
    }
    return JSON.parse(saved);
  });

  const savePeople = (newPeople) => {
    setPeople(newPeople);
    localStorage.setItem("appuntamenti", JSON.stringify(newPeople));
  };

  const removeItem = (id) => {
    savePeople(people.filter((p) => p.id !== id));
  };

  const reloadAllItem = () => {
    savePeople(data);
  };

  const [formData, setFormData] = useState({
    nome: "", stato: "", img: "", data: "", ora: "", luogo: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const aggiungiAppuntamento = (e) => {
    e.preventDefault();
    const nuovoAppuntamento = { ...formData, id: new Date().getTime() };
    savePeople([...people, nuovoAppuntamento]);
    setShowForm(false);
    setFormData({ nome: "", stato: "", img: "", data: "", ora: "", luogo: "" });
  };

  return (
    <section>
      <div className="container">
        <h2 style={{ color: "var(--bg-blue)" }}>Agenda Appuntamenti</h2>
        <div className="people-list">
          <List data={people} removeItem={removeItem} />
        </div>

        {showForm && (
          <form onSubmit={aggiungiAppuntamento} className="item">
            <div>
              <input name="nome" placeholder="Nome" value={formData.nome} onChange={handleChange} required />
              <input name="stato" placeholder="Stato" value={formData.stato} onChange={handleChange} />
              <input name="img" placeholder="URL immagine" value={formData.img} onChange={handleChange} />
              <input name="data" placeholder="Data (gg-mm-aaaa)" value={formData.data} onChange={handleChange} />
              <input name="ora" placeholder="Ora (hh:mm)" value={formData.ora} onChange={handleChange} />
              <input name="luogo" placeholder="Luogo" value={formData.luogo} onChange={handleChange} />
              <button type="submit" className="btn button">Salva</button>
              <button type="button" className="btn" onClick={() => setShowForm(false)}>Annulla</button>
            </div>
          </form>
        )}

        <div className="btn-group">
          <button className="btn btn-reset" onClick={reloadAllItem}>Reload</button>
          <button className="btn btn-aggiungi" onClick={() => setShowForm(!showForm)}>
            {showForm ? "Chiudi Form" : "Aggiungi Appuntamento"}
          </button>
          <button className="btn btn-delete" onClick={() => savePeople([])}>Delete all</button>
        </div>
      </div>
    </section>
  );
}

export default App;

